import { useEffect } from 'react';
import { useSiteSettings } from '../SiteSettingsContext';
import { useAuth } from '../auth/AuthContext';
import { initClarity, resolveClarityProjectId } from './clarity';
import { setAnalyticsSuppressed } from '../analytics';

/** Loads Microsoft Clarity when a project ID is configured. */
export default function ClarityInit() {
  const { settings: site } = useSiteSettings();
  const { ready, isStaff } = useAuth();

  useEffect(() => {
    setAnalyticsSuppressed(!ready || isStaff);
  }, [ready, isStaff]);

  useEffect(() => {
    if (!ready || isStaff) return;
    const id = resolveClarityProjectId(site);
    if (!id) return;
    initClarity(id);
  }, [ready, isStaff, site]);

  return null;
}
